import React, { useCallback, useState } from 'react';
import { useEffect } from "react"
import { useSelector } from 'react-redux';

export interface EventTarget {
  target: {
    name: string,
    value: string
  }
}

/**
 * It extracts rotation and scale change implementation from FormEdit.js. is is used in 
 * Mobile Footer : Image Tab. It does not include the increment/decrement of rotation/scale using
 * +/- buttons
 */
export const useImageSettings = () => {

  const makFabric = useSelector((state: any) => state.makFabric)
  const activeObj = useSelector((state: any) => state.activeObj)

  const [rand, setRand] = useState(1)

  const [formState, setFormState] = useState({
    scale: 100,
    rotation: 0,
  });

  useEffect(() => {
    if (makFabric) {
      makFabric.help.selectedObj = () => setRand(Math.random() * 100)
    }
    return () => { makFabric.help.selectedObj = () => { } }
  }, [makFabric]);

  useEffect(() => {
    if (rand && makFabric && activeObj && activeObj.type === "image") {
      setFormState({
        scale: Math.round(activeObj.scaleX * 100),
        rotation: Math.round(activeObj.angle),
      })
    }
  }, [makFabric, activeObj, rand])

  const handleScaleChange = useCallback((event: EventTarget) => {
    const { target } = event
    setFormState((prev) => ({
      ...prev,
      [target.name]: target.value.replace(/[^+\d]/g, ""),
    }))

    makFabric.scaleObject(activeObj, target.value.replace(/[^+\d]/g, ""))
  }, [makFabric, activeObj])

  const changeRotation = useCallback((event: EventTarget) => {
    const { target } = event;
    setFormState(prev => ({
      ...prev,
      [target.name]: target.value.replace(/[^+\d]/g, ""),
    }))

    makFabric.rotateObject(activeObj, target.value.replace(/[^+\d]/g, ""))
  }, [makFabric, activeObj])

  return {
    formState,
    handleScaleChange,
    changeRotation,
  }
}